import { AccentVariantEnum } from '@delmonicos/shared-design-system-react/src/components/accent-icon/accent-icon';
import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Icon } from '@delmonicos/shared-design-system-react/src/components/icon/icon';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import {
  Text,
  TextFontSize,
} from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { OcppAuthenticationLayer } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/enums/authentication/ocpp-authentication-layer.enum';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as css from '@app/feature/charge-point/charge-point-configuration/charge-point-configuration.module.scss';
import { useChargePointContext } from '@app/feature/charge-point/charge-point.context';

export const AuthenticationTabComponent = (): React.JSX.Element => {
  const { t } = useTranslation();
  const chargePoint = useChargePointContext();

  return (
    <Stack
      className={css.authenticationTab}
      direction="column"
      gap={GapEnum.L}
      flex={1}>
      <Card className={css.authenticationCard} flex={1} gap={GapEnum.M}>
        <AccentTitle
          as={HeadingEnum.H2}
          icon="log-in-02"
          text={t(
            'delmonicos-shared-sdk.outputs-charge-point.authentication-layer',
          )}
          variant={AccentVariantEnum.Accent1}
        />
        <Stack alignItems="center" justifyContent="space-between">
          <Text bold fontSize={TextFontSize.Large}>
            {t(
              'delmonicos-shared-sdk.outputs-charge-point.authentication-layer',
            )}
          </Text>
          <Text fontSize={TextFontSize.Large}>
            {chargePoint.authenticationLayer ===
            OcppAuthenticationLayer.NONE ? (
              <Stack alignItems="center" gap={GapEnum.XS}>
                <Text>{t('global.no')}</Text>
                <Icon name="x-circle" />
              </Stack>
            ) : (
              <Stack alignItems="center" gap={GapEnum.XS}>
                <Text>{t('global.yes')}</Text>
                <Icon name="check-circle" />
              </Stack>
            )}
          </Text>
        </Stack>
        <Stack direction="column" gap={GapEnum.M}>
          <Stack alignItems="center" justifyContent="space-between">
            <Text bold fontSize={TextFontSize.Large}>
              {t('delmonicos-shared-sdk.outputs-charge-point.authorized-ips')}
            </Text>
            <Text>
              {chargePoint.authorizedIps &&
              chargePoint.authorizedIps.length === 0
                ? '-'
                : ''}
            </Text>
          </Stack>
          {chargePoint.authorizedIps &&
            chargePoint.authorizedIps.length > 0 && (
              <div className={css.authorizedIpWrapper}>
                {chargePoint.authorizedIps.map((ip) => (
                  <Text key={ip} className={css.authorizedIp}>
                    {ip}
                  </Text>
                ))}
              </div>
            )}
        </Stack>
      </Card>
    </Stack>
  );
};
